/**
 Note: the enumerable property is important, as it appears on not in Object.keys used by ban.service.mjs to build the url
 */
export class SearchConfig{
    constructor(){
        var typeSet = new Set(['housenumber','street','locality','municipality']);
        var _query;
        var _mainCity = '',
            _bounds
        ;

        Object.defineProperty(this,'q',{
            set : function(q){ _query = q  },
            get : function(){ 
				var query = _query || '';
				return `${query} ${this.mainCity}` 
			},
            enumerable : true
        })

        this.limit = 5;
        this.autocomplete = "false";
        this.lat;
        this.lon;
        this.type="street";
        this.postcode;
        this.citycode;
        Object.defineProperty(this,'bounds',{    // Change. Prefer [44.59, -1.03, 45.06, -0.36],
            set : function(b){ _bounds = b },
            get : function(){ return _bounds },
            enumerable : false
        })
        
        Object.defineProperty(this,'mainCity',{
            set : function(city){ _mainCity = city },
            get : function(){ return _mainCity || '' },
            enumerable : false 
        })
    }

    getQuery(){ return this.query }

    setQuery(query){ this.q = query }

    setLimit(limit){ 
        if (limit<0) this.limit = '';
        else this.limit = limit;
    }

    setMainCity(city){ this.mainCity = city }

    getBounds(){ return this.bounds }

    setBounds(swPoint, nePoint){ 
        this.bounds = new Bounds(swPoint, nePoint);
    }

    setBoundsValues(swLat,swLon, neLat, neLon){
        var swPoint = new Point(swLat,swLon);
        var nePoint = new Point(neLat,neLon);
        this.bounds = new Bounds(swPoint, nePoint);
    }
}


export class Point{    // TMP move to GIS 
    constructor(lat,lon){
        var _lat = lat; 
        var _lon = lon;
        
    
        Object.defineProperty(this,'lat',{
            set : function(l){ _lat = l },
            get : function(){ return _lat },
            enumerable : true 
        })

        Object.defineProperty(this,'lon',{
            set : function(l){ _lon = l },
            get : function(){ return _lon },
            enumerable : true 
        })

    }

    getLatitude(){ return this.lat }
    getLongitude(){ return this.lon }

    getAsArray(){ return [ this.lat, this.lon] }
}

export class Bounds{   // TMP move to GIS 
    constructor(swPoint, nePoint){
        var _sw = swPoint;
        var _ne = nePoint;

        this.sw = _sw;
        this.ne = _ne;
    }

    getNorthEastPoint(){ return this.ne }
    getSouthWestPoint(){ return this.sw }
    setSouthWestPoint(point){ this.sw = point }
    setNorthEastPoint(point){ this.ne = point }

}


export class BanServicesConfig{
    constructor(){
        this.search = new SearchConfig();
    }

    getSearchConfig(){ return this.search; }
	setSearchConfig(searchConfig) { 
		if (searchConfig.constructor === SearchConfig) this.search = searchConfig 
	} //check type 


}




/**
q
limit 
autocomplete 
lat lon
type postcode citycode 
 */